import React, { Component } from 'react';
import { Animate } from 'react-simple-animate';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import CustomersPowerSelect from '../customers/customers-power-select.jsx';
import moment from 'moment';
import StatefulMultiSelect from "@khanacademy/react-multi-select";

export default class PortalDailyDeliveredLogTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      play: false,
      startDate: moment().toDate(),
      endDate: moment().toDate(),
      isLoading: false,
      customers: [],
      selected_date: new Date(),
      selectedCustomers: [],
      getReportUrl: '/api/v1/portal/portal-admin/erac-report/',
      dailyDeliveredCarReportData: [],
      selected: [],
      url: "/api/v1/portal/customers/all/for-dropdown-menu",
    };
    this.handleDeliveredDateCalenderChange = this.handleDeliveredDateCalenderChange.bind(this);
    this.handleCustomerSelection = this.handleCustomerSelection.bind(this);
    this.handleStartDateChange = this.handleStartDateChange.bind(this);
    this.handleEndDateChange = this.handleEndDateChange.bind(this);
    this.handleDailyDeliveredCarReportGeneration = this.handleDailyDeliveredCarReportGeneration.bind(this);
  }
  componentDidMount() {
    let options = [];
    return fetch(this.state.url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer ' + window.api_token
        , "Accept": 'application/json'
      },
    }).then((responseText) => {
      let response = responseText.json();
      response.then((response) => {
        response.map((customer) => {
          options.push({
            label: customer.company.short_name + '-' + customer.name,
            value: customer.id
          });
        });
        this.setState({
          customers: options,
          isLoading: false
        });
      });
    });
  }
  handleDeliveredDateCalenderChange(date) {
    this.setState({
      selected_date: date
    });
  }
  handleStartDateChange(date) {
    this.setState({ startDate: date })
  }
  handleEndDateChange(date) {
    this.setState({ endDate: date })
  }
  handleCustomerSelection(selectedCustomers) {
    this.setState({ selectedCustomers });
  }
  handleDailyDeliveredCarReportGeneration(e) {
    this.setState({
      isLoading: true
    })
    let dailyDeliveredLogData = {};
    dailyDeliveredLogData.selected_date = moment(this.state.selected_date).format("YYYY-MM-DD");
    dailyDeliveredLogData.selected_customer = this.state.selectedCustomers;

    let url = this.state.getReportUrl + dailyDeliveredLogData.selected_date;
    return fetch(url, {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer ' + window.api_token
        , "Accept": 'application/json'
      },
      body: JSON.stringify({
        start_date: moment(this.state.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.state.endDate).format("YYYY-MM-DD"),
        customer_ids: dailyDeliveredLogData.selected_customer
      }),
    }).then((responseText) => {
      let response = responseText.json();
      response.then((response) => {
        this.setState({
          dailyDeliveredCarReportData: response,
          isLoading: false
        })
      });
    });
  }
  download(filename, text) {
    filename = filename+' From '+moment(this.state.startDate).format("YYYY-MM-DD")+' To '+moment(this.state.endDate).format("YYYY-MM-DD")+'.csv';
    let element = document.createElement('a');
    element.setAttribute('href','data:text/plain;charset=utf-8,' + encodeURIComponent(text));
    element.setAttribute('download', filename);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }
  render() {
    let deliveredCars = [];
    const { selectedCustomers } = this.state;
    let downloadableCsvDataDelivered = "JOB REF,CUSTOMER JOB NUMBER,Reg/VIN,DELIVERED DATE,FROM,TO,JOB PRICE,APPROVED FUEL EXPENSES,ELECTRIC CHARGING COST, RELEASE CODE\n";
    let totalExpenseLength = 0;
    let totalCharingCost = 0;

    if (this.state.dailyDeliveredCarReportData.length > 0) {
      this.state.dailyDeliveredCarReportData.map((currentJob, index) => {
        totalExpenseLength = (currentJob.expense_approvals != null) ? (totalExpenseLength < currentJob.expense_approvals.length) ? currentJob.expense_approvals.length : totalExpenseLength : 0;
      });
    }

    if (this.state.dailyDeliveredCarReportData.length > 0) {
      this.state.dailyDeliveredCarReportData.map((currentJob, index) => {
        totalCharingCost = (currentJob.chargingCost != null) ? (totalExpenseLength < currentJob.chargingCost.length) ? currentJob.chargingCost.length : totalExpenseLength : 0;
      });
    }

    if (this.state.dailyDeliveredCarReportData.length > 0) {
      this.state.dailyDeliveredCarReportData.map((currentJob, index) => {

        let joburl = "/jobs/view/" + currentJob.expense_data.job_id;
                deliveredCars.push(
                  <tr key={index}>
                    <td><a href={joburl}>{currentJob.expense_data.job_id}</a></td>
                    <td>{currentJob.expense_data.job_number}</td>
                    <td>
                      {currentJob.expense_data.registration_number}
                    </td>
                    <td>
                      {currentJob.expense_data.driver_completed_at ? moment(currentJob.expense_data.driver_completed_at).format("DD.MM.YY") : '-'}
                    </td>
                    <td>
                      <div className='tabledatawrap'>{currentJob.expense_data.pickup_address || '-'}</div>
                    </td>
                    <td>
                      <div className='tabledatawrap'>{currentJob.expense_data.dropoff_address || '-'}</div>
                    </td>
                    <td>
                      {currentJob.expense_data.job_price || '-'}
                    </td>
                    <td>
                      {currentJob.expense_data.fuel_expense}
                    </td>
                    <td>
                      {currentJob.expense_data.charging_cost}
                    </td>
                    <td>
                      {currentJob.expense_data.release_code}
                    </td>
                  </tr>
                );
                downloadableCsvDataDelivered = downloadableCsvDataDelivered+currentJob.expense_data.job_id+','+currentJob.expense_data.job_number+','+(currentJob.expense_data.registration_number)+','+(currentJob.expense_data.driver_completed_at ? moment(currentJob.expense_data.driver_completed_at).format("DD.MM.YY") : '-')+','+(currentJob.expense_data.pickup_address || '-')+','+(currentJob.expense_data.dropoff_address || '-')+','+(currentJob.expense_data.job_price || '-')+','+currentJob.expense_data.fuel_expense+','+currentJob.expense_data.charging_cost+','+((currentJob.expense_data.release_code !== null) ? currentJob.expense_data.release_code : '')+'\n';
      });
    } else {
      deliveredCars.push(
        <tr key='no-records'><td colSpan="14" className='text-center'>No Records</td></tr>
      );
    }

    return (
      <div>
        <div className="row">
          <div className="col-md-12 col-sm-12">
            <h2>ERAC Report</h2>
          </div>
        </div>
        <br />
        <div className="row">

          <div className="col-md-1">
            <label><h5>Select Start Date:</h5></label><br />
            <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleStartDateChange} selected={this.state.startDate} />
          </div>
          <div className="col-md-1">
            <label><h5>Select End Date:</h5></label><br />
            <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleEndDateChange} selected={this.state.endDate} />
          </div>
          <div className="col-md-3 col-sm-12">
            <label><h3>Select Customer</h3></label><br />

            <div>
              <StatefulMultiSelect
                options={this.state.customers}
                selected={selectedCustomers}
                onSelectedChanged={this.handleCustomerSelection}
                overrideStrings={{
                  selectSomeItems: "Select Customers...",
                  allItemsAreSelected: "All Customers are Selected",
                  selectAll: "Select All",
                  search: "Search",
                }}
              />
            </div>

          </div>
          <div className="col-md-2 col-sm-12">
            <button className="btn btn-lg btn-success daily-delivered-btn-margin" onClick={this.handleDailyDeliveredCarReportGeneration}>
              <i className="fa fa-save"></i> Generate Report
            </button>
          </div>
          <div className="col-md-2 col-sm-12">
            <button className="btn btn-primary btn-lg daily-delivered-btn-margin"
              onClick={(e) => {
                this.download("ERAC report.csv", downloadableCsvDataDelivered);
              }}>
              <i className="fa fa-download"></i> Download for Spreadsheet
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 col-sm-12">
            <div className="daily-delivered-report-tbl-scroll">
              <table className="daily-delivered-report-tbl">
                <thead>
                  <tr>
                    <th>JOB REF</th>
                    <th>CUSTOMER JOB NUMBER</th>
                    <th>Reg/VIN</th>
                    <th>DELIVERED DATE</th>
                    <th>FROM</th>
                    <th>TO</th>
                    <th>JOB PRICE</th>
                    <th>APPROVED FUEL EXPENSES</th>
                    <th>ELECTRIC CHARGING COST</th>
                    <th>RELEASE CODE</th>
                  </tr>
                </thead>
                <tbody>

                  {this.state.isLoading ?
                    (<tr><td colSpan="14"><span className="add-loading-text">
                      <i className="fa fa-spinner fa-pulse"></i></span></td></tr>) :
                    deliveredCars
                  }
                </tbody>
              </table>
            </div>
            <br /><br /><br />
          </div>
        </div>
      </div>
    );
  }
}